export const PLAY_FORMATS = [
  "Commander",
  "Canadian Highlander",
  "Modern",
  "Standard",
  "Pioneer",
  "Legacy",
  "Vintage",
  "Pauper",
  "Draft",
  "Sealed",
  "MTG Arena",
  "Explorer",
  "Historic",
  "Alchemy",
  "D&D (non-MTG)",
] as const;

export type PlayFormat = (typeof PLAY_FORMATS)[number];

// Map display format -> Scryfall legality key
// Only formats that Scryfall exposes will be used for legality checks.
// Others are treated as "no legality checks".
export function scryfallFormatKey(fmt: string): string | null {
  const f = fmt.toLowerCase();
  if (f === "commander") return "commander";
  if (f === "canadian highlander") return "canadianhighlander";
  if (f === "modern") return "modern";
  if (f === "standard") return "standard";
  if (f === "pioneer") return "pioneer";
  if (f === "legacy") return "legacy";
  if (f === "vintage") return "vintage";
  if (f === "pauper") return "pauper";
  if (f === "explorer") return "explorer";
  if (f === "historic") return "historic";
  if (f === "alchemy") return "alchemy";
  // Treat formats without Scryfall legality as non-checking
  return null; // Draft, Sealed, MTG Arena (umbrella), D&D
}
